import { CIcon } from '~/icons/types'

export const ciDownhillBike: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M18.869 10.678a4.1 4.1 0 0 0-.927.114l-1.367-3.837h1.201a.592.592 0 0 0 .464-.345l.353-.773a.476.476 0 0 0-.867-.395l-.256.56H15.9a.477.477 0 0 0-.45.637l.174.486-6.7 2.476-1.04-3.584.47.002h.002a.476.476 0 0 0 0-.953l-2.21-.006h-.001a.476.476 0 0 0-.002.952l.75.003 1.23 4.242-.86 1.033a4.088 4.088 0 0 0-2.13-.61 4.131 4.131 0 1 0 4.048 4.945 1.225 1.225 0 0 0 .692.234 1.265 1.265 0 0 0 1.267-1.257 1.232 1.232 0 0 0-.083-.41l5.392-4.752.6 1.681a4.1 4.1 0 1 0 1.82-.442Zm-11.46 1.923a3.17 3.17 0 0 1 .82 1.519H6.148Zm1.033-1.241.658 2.266c-.008.007-.018.01-.026.017a4.124 4.124 0 0 0-1.052-1.778Zm-3.31 6.628a3.179 3.179 0 1 1 0-6.357 3.138 3.138 0 0 1 1.513.4l-1.88 2.26a.476.476 0 0 0 .366.781h3.152a3.172 3.172 0 0 1-3.152 2.916Zm5.294-4.512a1.24 1.24 0 0 0-.411-.113l-.825-2.845 6.754-2.495.051.145.109.304Zm8.443 4.512a3.168 3.168 0 0 1-1.5-5.964l1.05 2.949a.477.477 0 0 0 .45.316.46.46 0 0 0 .16-.028.477.477 0 0 0 .289-.608l-1.055-2.96a3.177 3.177 0 1 1 .606 6.295Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'downhill-bike',
  type: 'thin'
}
